import React from "react";
import styles from "./TableORA.module.css";

const TableORA = ({
  resultData,
  selectedRows,
  setSelectedRows,
}) => {
  const columns = [
    "id",
    "p-value",
    "fdr p-value",
    "cut off 0.05",
    "cut off 0.01",
    "cut off 0.001",
    "pathway",
    "source",
    "overlap",
    "level",
    "select for plot",
  ];

  const toggleRowSelection = (index) => {
    if (selectedRows.includes(index)) {
      // 만약 행이 이미 선택된 경우
      setSelectedRows(selectedRows.filter((i) => i !== index)); // 해당 행을 배열에서 제거
    } else {
      // 행이 선택되지 않은 경우
      setSelectedRows([...selectedRows, index]); // 해당 행을 배열에 추가
    }
  };

  return (
    <div className={styles.table}>
      <table>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} className={styles.th}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={styles.tbody}>
          {resultData.map(
            (
              {
                pvalue_string,
                qvalue,
                q_005,
                q_001,
                q_0001,
                pathway,
                source,
                size,
                overlap,
                cancerLevel,
              },
              index
            ) => (
              <tr
                key={
                  pvalue_string + pathway + size + overlap + cancerLevel + index
                }
                onClick={() => toggleRowSelection(index)}
              >
                <td className={styles.td} style={{ maxWidth: "25px" }}>
                  {index + 1}
                </td>
                <td style={{ maxWidth: "30px"}} className={styles.td}>
                  {pvalue_string}
                </td>
                <td style={{ maxWidth :'75px'}} className={styles.td}>
                  {qvalue}{" "}
                </td>
                <td style={{ maxWidth: "60px"}} className={styles.td}>
                  {q_005}{" "}
                </td>
                <td style={{ maxWidth: "60px"}} className={styles.td}>
                  {q_001}{" "}
                </td>
                <td style={{ maxWidth: "60px"}} className={styles.td}>
                  {q_0001}{" "}
                </td>
                <td
                  style={{
                    maxWidth: "220px",
                    width: "100%",
                    textAlign: "left",
                  }}
                  className={styles.td}
                >
                  {pathway}
                </td>
                <td className={styles.td}>{source}</td>
                <td className={styles.td}>
                  {overlap}/{size}
                </td>
                <td className={styles.td}>{cancerLevel}</td>
                <td className={styles.td}>
                  <input 
                  type="checkbox" 
                  checked={selectedRows.includes(index)} 
                  onChange={() => toggleRowSelection(index)} 
                  />
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableORA;
